import React,{ useEffect, useState } from 'react';

import DataGrid, {
    Column,
    ColumnChooser,
    Editing,
    Export,
    FilterRow,
    HeaderFilter,
    Pager,
    Paging,      
    Button as ButtonGrid, 
    Summary,
    TotalItem
} from 'devextreme-react/data-grid';

import BlockHeader from '../../components/shared/BlockHeader';
import Title from '../../components/shared/Title';
import onExporting from '../../components/grids/Importer';
import http from '../../utils/http';
import { cellRender, cellRenderBold, formatToMoney } from '../../utils/common';

const Stock = () => {

    const [report, setReport] = useState([]);

    const getDataAsync = async () => {

        const data = await http('reports/inventario/stock').asGet();

        const dataProcessed = data.map(item =>  {

            item.totalCost = item.stock * item.cost;
            item.totalPrice = item.stock * item.price;

            return item;

        });

        setReport(dataProcessed); 

    }

    useEffect(() => {
        
        getDataAsync();
        
    }, [0]);

    const onCellPrepared = e => {
        
        if (e.rowType == 'data') {    
            if(e.column.dataField == "stock" && e.data.stockMin)
                if(e.data.stock < e.data.stockMin)
                    e.cellElement.classList.add('txt-stockMin');  
                else
                    e.cellElement.classList.add('txt-stock');  

        }

    }

    const title = 'Inventario';

    return (
        <div className="container">
            <Title title={title} />
            <BlockHeader title={title} />    
            <DataGrid id="gridContainer"
                selection={{ mode: 'single' }}
                dataSource={report}
                showBorders={true}
                showRowLines={true}
                allowColumnResizing={true}
                allowColumnReordering={true}
                hoverStateEnabled={true}
                onCellPrepared={onCellPrepared}
                onExporting={(e) => onExporting(e, title)}
            >
                <Paging defaultPageSize={20} />
                <Pager
                    showPageSizeSelector={true}
                    allowedPageSizes={[10, 20, 50]}
                    showInfo={true}
                />
                <Export enabled={false} fileName={title} allowExportSelectedData={true} />
                <FilterRow visible={true} />
                <HeaderFilter visible={true} />
                <ColumnChooser enabled={true} />
                <Column dataField="code" caption='Codigo'  width={100}/>
                <Column dataField="type" caption="Tipo"  width={170} allowHeaderFiltering={false}/>
                <Column dataField="name" caption='Nombre' />
                <Column dataField="stock" caption='Existencia' width={120}/>
                <Column dataField="cost" caption='Costo Comp' width={120} cellRender={cellRender()} allowHeaderFiltering={false}/>
                <Column dataField="profitPercent" caption="Utilidad" width={100} format="#0%" allowHeaderFiltering={false}/>
                <Column dataField="price" caption="Precio Vta" width={100} cellRender={cellRender()}  allowHeaderFiltering={false}/>
                <Column dataField="totalCost" caption='Total Costo' width={120} cellRender={cellRenderBold()} allowHeaderFiltering={false}/>
                <Column dataField="totalPrice" caption='Total Precio Vta' width={120} cellRender={cellRenderBold()} allowHeaderFiltering={false}/>
                <Summary>                
                    <TotalItem
                        column="totalCost"
                        summaryType="sum" customizeText={data => `${formatToMoney(data.value)}`} />
                    <TotalItem
                        column="totalPrice"
                        summaryType="sum" customizeText={data => `${formatToMoney(data.value)}`} />
                </Summary>
            </DataGrid>
        </div>
    );
}

export default Stock;
